//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
let d=[[],[[["n_matched_references"],"GetMatchedReferences",{R_:{matched_reference_data:"Features.MatchedReferenceBuilder[]"}},0,0],[["match_based_on_name"],"AutomaticMatch",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.FeatureReferencesBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FeatureReferencesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;